// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollRef_root__Uj1HJ","root--absolute":"ScrollRef_root--absolute__zzLVh","ref":"ScrollRef_ref__T6kkl","rotation":"ScrollRef_rotation__RP5EJ"};